import { v4 as uuidv4 } from "uuid"

export interface InputPreset {
  id: string
  name: string
  inputs: Record<string, unknown>
}

const KEY_PREFIX = "userbot.templatePresets."

const keyFor = (templateId: string) => `${KEY_PREFIX}${templateId}`

/** Список сохранённых пресетов ввода для шаблона. */
export const listPresets = (templateId: string): InputPreset[] => {
  try {
    const raw = localStorage.getItem(keyFor(templateId))
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as InputPreset[]) : []
  } catch {
    return []
  }
}

const write = (templateId: string, presets: InputPreset[]) =>
  localStorage.setItem(keyFor(templateId), JSON.stringify(presets))

/** Сохраняет новый пресет ввода и возвращает его. */
export const savePreset = (
  templateId: string,
  name: string,
  inputs: Record<string, unknown>,
): InputPreset => {
  const preset: InputPreset = { id: uuidv4(), name, inputs }
  write(templateId, [...listPresets(templateId), preset])
  return preset
}

/** Удаляет пресет по id. */
export const deletePreset = (templateId: string, id: string): void => {
  write(
    templateId,
    listPresets(templateId).filter((p) => p.id !== id),
  )
}
